"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.router = exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _vueRouter = _interopRequireDefault(require("vue-router"));
var _vueGtag = _interopRequireDefault(require("vue-gtag"));
var _attendanceRecordsRoutes = _interopRequireDefault(require("./attendanceRecordsRoutes"));
var _plantNurseryRoutes = _interopRequireDefault(require("./plantNurseryRoutes"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
_vue.default.use(_vueRouter.default);
var router = exports.router = new _vueRouter.default({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/auth/login',
    name: 'auth',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/auth/login'));
      });
    },
    meta: {
      layoutFull: true
    }
  }, {
    path: '/auth/resend-email',
    name: 'resendEmail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/auth/resendEmail'));
      });
    },
    meta: {
      layoutFull: true
    }
  }, {
    path: '/auth/signup',
    name: 'signup',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/auth/signup'));
      });
    },
    meta: {
      layoutFull: true
    }
  }, {
    path: '/auth/recover-password',
    name: 'recover-password',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/auth/recoverPassword'));
      });
    },
    meta: {
      layoutFull: true
    }
  }, {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/privacy-policy'));
      });
    },
    meta: {
      layoutFull: true
    }
  }, {
    path: '/confirm-registration',
    name: 'confirm-registration',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/confirmRegistration'));
      });
    },
    meta: {
      layoutFull: true
    }
  }, {
    path: '/change-password',
    name: 'change-password',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/auth/changePassword'));
      });
    },
    meta: {
      layoutFull: true
    }
  }, {
    path: '/home',
    name: 'home',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/home'));
      });
    },
    redirect: '/farm-management/list',
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/services/schedule',
    name: 'schedule-of-services',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/services/schedule'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/services/types',
    name: 'types-services',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/services/typesServices'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/products/types',
    name: 'types-products',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/products/TypesProducts'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/account-management',
    name: 'AccountManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/accountManagement'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/account-management/detail',
    name: 'AccountManagementDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/accountManagement/details'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/services/archiveds',
    name: 'archived-services',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/services/archiveds'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/services/edit/list',
    name: 'edit-list-services',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/services/editService'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/ocurrrences/list',
    name: 'occurrences-list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/occurrences/list'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/ocurrrences/ratings',
    name: 'occurrences-ratings',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/occurrences/ratings'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/team/list',
    name: 'team-list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/team'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/farm-management/list',
    name: 'FarmList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/farm'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/farm-management/dashboard',
    name: 'Dashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/dashboard'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/farm-management/map',
    name: 'map',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/farm/map'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/farm-management/routes',
    name: 'routes',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/RoutesFarmManagement'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/farm-management/routes/:id',
    name: 'routesUser',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/RoutesFarmUserManagement'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/farm-management/productiveareas',
    name: 'ProductiveAreas',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/productiveAreas/list'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/farm-management/productiveareas/:id',
    name: 'ProductiveAreasDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/productiveAreas/detail'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/farm-management/farm-data',
    name: 'FarmData',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/farmData'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/stock',
    name: 'Estoque',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/stock'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/identifiers',
    name: 'Identificadores',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/identifiers'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/payment-list-farms',
    name: 'PaymentListFarms',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/payment'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/payment-list-farms/details/:id',
    name: 'PaymentFarmsDetails',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/payment/details'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/faq',
    name: 'faq',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/faq'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/import-balance',
    name: 'importBalance',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/importBalance'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/traceabilitytags',
    name: 'traceabilitytags',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/traceabilitytags'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/valid-tag',
    name: 'valid-tag',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/validTag'));
      });
    },
    meta: {
      layoutFull: true
    }
  }, {
    path: '/customfields/list',
    name: 'custom-fields-list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/customFields/ListCustomFields.vue'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/customfields/list-client',
    name: 'custom-fields-list-client',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/customFields/ListCustomFieldsClient.vue'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/custom-reports',
    name: 'custom-reports',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/customReports'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }].concat(_toConsumableArray(_attendanceRecordsRoutes.default), _toConsumableArray(_plantNurseryRoutes.default), [{
    path: '/applications/list',
    name: 'applications',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/applications'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/applications/structure',
    name: 'applications-structure',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/applications/structure'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/applications/product',
    name: 'applications-product',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/applications/product'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/applications/prescription',
    name: 'applications-prescription',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/applications/prescription'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/applications/application',
    name: 'applications-application',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/applications/application'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/applications/equipment',
    name: 'applications-equipment',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/flow/applications/ApplicationEquipment'));
      });
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '*',
    redirect: '/auth/login'
  }])
});
_vue.default.use(_vueGtag.default, {
  config: {
    id: process.env.VUE_APP_API_KEY_GA
  },
  pageTrackerTemplate: function pageTrackerTemplate(to) {
    return {
      page_title: to === null || to === void 0 ? void 0 : to.name,
      page_path: to.path
    };
  }
}, router);
var _default = exports.default = router;